import { WeixinQrcode } from '@prisma/client'

export enum TaskStatus {
  PENDING,
  SUCCESS,
  FAILURE,
}

export enum QrcodeStatus {
  NOT_SCANNED = 'NOT_SCANNED',
  SCANNED = 'SCANNED',
  EXPIRED = 'EXPIRED',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export type QrcodeData = Pick<WeixinQrcode, 'sceneStr' | 'ticket' | 'status' | 'createdAt' | 'expireSeconds'>
